export default __webpack_public_path__ + "static/media/EESymbolsImg12.a85796cf.jpg";